<div class="main-page__container">
  <menu-component></menu-component>
  <router-outlet class="main-page__router-outlet"></router-outlet>
</div>
